"use client"

import { usePathname } from "next/navigation"
import { JourneyLoading } from "../src/components/journey-loading.tsx"
import { isConsumerAppPath } from "../src/lib/consumer-navigation.ts"
import { resolveUserRoute } from "../src/lib/routes.ts"

export default function Loading() {
  const pathname = usePathname()
  const route = pathname === null ? null : resolveUserRoute(pathname)
  if (pathname !== null && route !== null && isConsumerAppPath(pathname)) return <JourneyLoading route={route} />
  return (
    <main className="state-main" id="main-content">
      <output aria-busy="true" aria-label="페이지를 불러오는 중" className="state-card">
        <div aria-hidden="true" className="state-icon state-icon-loading">
          <span className="state-icon-dot" />
        </div>
        <div className="skeleton-lines">
          <span className="skeleton-line" />
          <span className="skeleton-line skeleton-line-medium" />
          <span className="skeleton-line skeleton-line-short" />
        </div>
      </output>
    </main>
  )
}
